import { render, staticRenderFns } from "./userIndustryReport.vue?vue&type=template&id=8411422a&scoped=true"
import script from "./userIndustryReport.vue?vue&type=script&lang=js"
export * from "./userIndustryReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8411422a",
  null
  
)

export default component.exports